export default {
  "content": "<title>arrow right</title><path d=\"M9 19.5l7.5-7.5L9 4.5v15z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "height": "24",
    "viewBox": "0 0 24 24",
    "width": "24"
  }
};